import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowRightIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileArrowRightIn"><Path d="M16.8105 16L14.5605 18.25H21V19.75H14.5605L16.8105 22L15.75 23.0605L11.6895 19L15.75 14.9395L16.8105 16Z" fill="currentColor"/><Path d="M12 10H20V16.75H18.1816L18.9316 16L15.75 12.8184L11.8184 16.75H11.75V16.8184L9.56836 19L11.75 21.1816V21.25H11.8184L12.5684 22H4.75C4.33579 22 4 21.6642 4 21.25V2.75C4 2.33579 4.33579 2 4.75 2H12V10Z" fill="currentColor"/><Path d="M19.5605 8.5H13.5V2.43945L19.5605 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileArrowRightIn;
